module.exports = __webpack_public_path__ + "static/media/monitors.b7fdd280.svg";